'use client';
import React, { memo } from 'react';

interface AIMakerLogoProps {
  size?: number;
  variant?: 'color' | 'white' | 'black';
  className?: string;
  showText?: boolean;
  textSize?: string;
}

const AIMakerLogo = memo(function AIMakerLogo({
  size = 96,
  variant = 'color',
  className = '',
  showText = false,
  textSize = 'text-lg',
}: AIMakerLogoProps) {
  const isWhite = variant === 'white';
  const isBlack = variant === 'black';

  return (
    <div className={`flex items-center ${className}`}>
      <div
        style={{
          width: size,
          height: size,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        aria-label="AIMaker Studio logo"
        role="img"
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="/assets/images/AIMakerStudioOfficial_Logo1transparentbg-1782418159010.png"
          alt="AIMaker Studio logo"
          style={{
            width: size,
            height: size,
            objectFit: 'contain',
            display: 'block',
            filter: isWhite
              ? 'brightness(0) invert(1)'
              : isBlack
              ? 'brightness(0)'
              : 'none',
          }}
        />
      </div>

      {showText && (
        <span
          className={`${textSize} font-semibold ${isWhite ? 'text-white' : isBlack ? 'text-black' : 'text-foreground'}`}
        >
          AIMaker Studio
        </span>
      )}
    </div>
  );
});

export default AIMakerLogo;
